import(/* webpackMode: "eager", webpackExports: ["Betting"] */ "/home/nexts/lm-master-front/src/flat-pages/betting/betting.tsx");
